import { SimplePolygonMapEntity } from "./simple-polygon-map-entity.service";
import { DataContextService } from "./data-context.service";
import { Color } from 'cesium';
import { MedLowGeometryMapEntity } from "./med-low-geometry-map-entity.service";
import { CameraService } from "./camera.service";
import { PolylineMapEntity } from "./polyline-map-entity.service";
import { CoreService } from "./core.service";
import { IncidentAttribute } from "./incident-attribute.service";
import { SessionOptionsService } from "./session-option.service";
import * as Cesium from 'cesium';
import _ from 'lodash';
import { GlobalSettingsService } from "./global-settings.service";
import { FocalPointMapEntity} from "./focal-point-map-entity.service";
import { WindowService } from "./window.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TimelineService } from "./timeline.service";
import { IncidentEditDialogComponent } from "../../components/shared/incident-edit-dialog/incident-edit-dialog.component";
import { DefaultEditCommand } from "../models/command";


// Add IncidentTimeSlice class
export class IncidentTimeSlice {
  constructor(
    public unSafeUsers: string[],
    public safeUsers: string[],
    public unknownUsers: string[],
    public affectedPerimetersMap: any
  ) {}
}

export class IncidentMapEntity extends SimplePolygonMapEntity  {
  override id: string;
  isMuster: boolean;
  outline: any;
  safezones: any[] = [];
  updates: any[] = [];
  devices: Record<string, any> = {};
  focalPoint: any = undefined;
  inDangerUsersLastCount = 0;
  unknownUsersLastCount = 0;
  safeUsersLastCount = 0;
  firstRespondersLastCount = 0;
  inDangerUsers: any;
  unknownUsers: any;
  safeUsers: any;
  dataTimeSlices: any;
  status: string;
  description: string;
  lastUpdate: Date;
  orgid: any;
  obj: any;
  eventId: string;
  focalPointGeo: any;
  affectedPerimeters: any[] = [];
  affectedBeacons: Record<string, any> = {};
  affectedPerimeterIds: string[] = [];
  buildingMapEntity: any;
  medGeometryMapEntity: any;
  lowGeometryMapEntity: any;
  override addedToMap = false;
  static ACTIVE_STATE = 'active';
  static PENDING_STATE = 'pending';
  static CLOSED_STATE = 'inactive';
 LIVE_MODE: string = 'Live Mode';
 public highGeometryMapEntities: any[] = [];
public medGeometryMapEntities: any[] = [];
public lowGeometryMapEntities: any[] = [];

  constructor(
    incident: any,
    private dataContextService: DataContextService,
    cameraService: CameraService,
    coreService: CoreService,
    private GlobalSettings: GlobalSettingsService,
    windowService: WindowService,
    modalService: NgbModal,
    timelineService: TimelineService,
    playback?: boolean,
    private FocalPointMapEntityClass?: any,
    private SessionOptionsService?: SessionOptionsService,
    private IncidentAttributeClass?: IncidentAttribute,
    private $timeout?: any
   
  ) {
    super('','',cameraService,coreService,windowService,dataContextService,modalService,timelineService);

    if (!incident.highGeometries || incident.highGeometries.length === 0) {
      throw new Error('Incident HighGeometry is undefined.');
    }
    let geoCoords = incident.highGeometries[0].coordinates[0];

    // If coordinates are in object form ({ lat, lon }), convert them to [lon, lat]
    if (Array.isArray(geoCoords) && geoCoords?.length && typeof geoCoords[0] === 'object' && !Array?.isArray(geoCoords[0])) {
      geoCoords = geoCoords?.map((coord: any) => {
        const lon = coord?.lon ?? coord?.lng ?? coord?.longitude;
        const lat = coord?.lat ?? coord?.latitude;
        return [Number(lon), Number(lat)];
      });
    }

    // Validate structure after conversion
    if (!Array.isArray(geoCoords) || geoCoords.some(coord => !Array.isArray(coord) || coord.length < 2)) {
      throw new Error('Invalid geometry coordinates: Expected an array of [longitude, latitude] pairs.');
    }

    const locations: [number, number][] = geoCoords.map(([lon, lat]: [number, number]) => [lat, lon]);
    this.setCoordinates(locations);
    this.isMuster = incident.isMuster;
 
    this.setMaterial(Cesium.Color.BLACK.withAlpha(0.01));
    this.setOutline(this.isMuster ? Cesium.Color.YELLOW : Cesium.Color.RED);
    this.setShowOutline(true);
    this.setOutlineWidth(3.0);
    this.setTimestamp(incident.createdAt);
 
    this.safezones = [];
    this.updates = [];
    this.devices = {};
    this.focalPoint = undefined;
    this.highGeometryMapEntities = [];
    this.medGeometryMapEntities = [];
    this.lowGeometryMapEntities = [];

    this.outline = new PolylineMapEntity(
      incident.label,
      incident.label,
      this.cameraService,
      coreService,
      this.reverseCoordinates(geoCoords),
      this.isMuster ? Cesium.Color.YELLOW : Cesium.Color.RED,
      3.0,
      this.windowService,
      this.dataContextService,
      this.modalService,
      this.timelineService
    );
    this.outline.setTimestamp(incident.createdAt);
    if (this.outline.setWindowId) this.outline.setWindowId(this.getWindowId());
    this.outline.setShowInOverlappingEntitiesUI(false);
    this.outline.viewDetailsWindow = function () {};
    this.outline.setShowInLayersUI(false);

    this.inDangerUsersLastCount = 0;
    this.unknownUsersLastCount = 0;
    this.safeUsersLastCount = 0;
    this.firstRespondersLastCount = 0;
    this.inDangerUsers = createNonExtrapolatedNumberSampleProperty();
    this.unknownUsers = createNonExtrapolatedNumberSampleProperty();
    this.safeUsers = createNonExtrapolatedNumberSampleProperty();
 
    this.dataTimeSlices = createObjectSampleProperty();
 
    this.status = incident.status;
    this.description = incident.description;
    this.lastUpdate = new Date(Date.parse(incident.updatedAt));
 
    this.setShowInLayersUI(false);

    if (playback) {
      const eventId = incident.eventId || incident.id || `playback-${Date.now()}`;
      this.id = `arc-angel-playback-${eventId}`;
      this.eventId = eventId;
    } else {
      const incidentId = incident.id || incident.eventId || `live-${Date.now()}`;
      this.id = `arc-angel-${incidentId}`;
      this.eventId = incidentId;
    }
 
    if (!this.isMuster) {
      this.addAttribute(new IncidentAttribute(this.getId()));
    }
 
    this.orgid = incident.organization;
 
    // Set commands
    this.removeDeleteCommand();
    this.removeShowHideCommand();
    this.removeTimelineCommand();
    this.removeTrackCommand();

    for (let i = 0; i < this.commands.length; i++) {
  const command = this.commands[i];
  if (command instanceof DefaultEditCommand) {
    (command as DefaultEditCommand).setModesVisible([this.LIVE_MODE]);
    break;
  }
}
    this.obj = incident;
  }
 
  // --- Added methods for building incident association ---
  setBuilding(buildingMapEntity: any): void {
    this.buildingMapEntity = buildingMapEntity;
    // this.addCommand(new PeelOffTextureCommand());
    for (const deviceId in this.devices) {
      if (Object.prototype.hasOwnProperty.call(this.devices, deviceId) && this.devices[deviceId]?.hide) {
        this.devices[deviceId].hide();
      }
    }
  }
 
  isBuildingIncident(): boolean {
    return this.buildingMapEntity !== undefined;
  }
 
  getBuilding(): any {
    return this.buildingMapEntity;
  }
  addHighGeometry(coords: any[]) {
    const entity = this.createPolygonEntity(coords, Cesium.Color.RED);
    this.highGeometryMapEntities.push(entity);
  }
    createPolygonEntity(
    coordinates: [number, number][],
    color: Color
  ): MedLowGeometryMapEntity {

    const entity = new MedLowGeometryMapEntity(
      this.eventId,
      coordinates,
      this.timestamp,
      color,
      this.dataContextService,
      this.cameraService,
      this.coreService,
      this.windowService,
      this.modalService,
      this.timelineService
    );

    entity.setParent(this);

    const entityId = entity.getId?.();
    if (!this.isClosed() && entityId && !this.dataContextService.isCesiumEntityPresent(entityId)) {
      this.dataContextService.addMapEntity(entity);
    }

    return entity;
  }


  addMedGeometry(coords: any[]) {
    const entity = this.createPolygonEntity(coords, Cesium.Color.ORANGE);
    this.medGeometryMapEntities.push(entity);
  }

  addLowGeometry(coords: any[]) {
    const entity = this.createPolygonEntity(coords, Cesium.Color.YELLOW);
    this.lowGeometryMapEntities.push(entity);
  }

  private updateGeometries(newGeos: any[], existingEntities: MedLowGeometryMapEntity[], color: Color): MedLowGeometryMapEntity[] {
    if (!newGeos) newGeos = [];

    const newCoordsStrings = newGeos.map(g => JSON.stringify(this.reverseCoordinates(g.coordinates[0])));

    const toRemove = existingEntities.filter(entity => {
      const entityCoordsString = JSON.stringify(entity.getCoordinates());
      return !newCoordsStrings.includes(entityCoordsString);
    });

    toRemove.forEach(entity => this.dataContextService.removeMapEntity(entity, true));

    let keptEntities = existingEntities.filter(entity => !toRemove.includes(entity));
    const keptCoordsStrings = keptEntities.map(entity => JSON.stringify(entity.getCoordinates()));

    const toAddCoordsStrings = newCoordsStrings.filter(newCoordsStr => !keptCoordsStrings.includes(newCoordsStr));

    toAddCoordsStrings.forEach(coordsString => {
      const newEntity = this.createPolygonEntity(JSON.parse(coordsString), color);
      keptEntities.push(newEntity);
    });

    return keptEntities;
  }

  public updateHighGeometries(newGeos: any[]) {
    const mainGeo = newGeos?.[0];
    if (mainGeo) {
      const mainGeoCoords = this.reverseCoordinates(mainGeo.coordinates[0]);
      this.setCoordinates(mainGeoCoords);
      this.outline.setCoordinates(mainGeoCoords);
    }

    const additionalHighGeos = newGeos || [];
    this.highGeometryMapEntities = this.updateGeometries(additionalHighGeos, this.highGeometryMapEntities, Cesium.Color.RED);
  }

  public updateMedGeometries(newGeos: any[]) {
    this.medGeometryMapEntities = this.updateGeometries(newGeos || [], this.medGeometryMapEntities, Cesium.Color.ORANGE);
  }

  public updateLowGeometries(newGeos: any[]) {
    this.lowGeometryMapEntities = this.updateGeometries(newGeos || [], this.lowGeometryMapEntities, Cesium.Color.YELLOW);
  }
 
  setIsMuster(muster: boolean): void {
    this.isMuster = muster;
  }
 
  getEventId() { return this.eventId; }
  setLastUpdate(lastUpdate: Date) { this.lastUpdate = lastUpdate; }
  getLastUpdate() { return this.lastUpdate; }
  setDescription(text: string) { this.description = text; this.obj.description = text; }
  setObj(obj: any) { this.obj = obj; }
  getObj() { return this.obj; }
  getOrganizationId() { return this.orgid; }
  getIsMuster() { return this.isMuster; }
  getTotalNumberOfUsersInsideIncident(time?: any) {
    if (time) {
      return this.inDangerUsers.getValue(time) + this.unknownUsers.getValue(time) + this.safeUsers.getValue(time);
    }
    return this.inDangerUsersLastCount + this.unknownUsersLastCount + this.safeUsersLastCount;
  }
  getIncidentType(): string {
    let type = 'unknown';
    if (this.obj && this.obj.type) {
      type = this.obj.type;
    }
    return type;
  }
  getIncidentUpdatesOnStreet(): any[] {
    return this.updates.filter((o: any) => !o.data.altitude);
  }
  addSafeZone(safezone: any) {
    this.safezones.push(safezone);
    if (!this.isClosed()) {
      this.dataContextService.addMapEntity(safezone);
      if (typeof safezone.drawPolygon === 'function') {
        safezone.drawPolygon();
      }
    }
  }
  removeSafeZone(safezone: any) {
    const index = this.safezones.indexOf(safezone);
    if (index > -1) {
      this.safezones.splice(index, 1);
      if (safezone.addedToMap) {
        this.dataContextService.removeMapEntity(safezone);
      }
    }
  }
  addUpdate(update: any) {
    this.updates.push(update);
    if (!this.isClosed() && !update.addedToMap) {
      this.dataContextService.addMapEntity(update);
    }
  }
  removeUpdate(update: any) {
    this.updates = this.updates.filter(u => {
      if (u.data.id === update.data.id) {
        if (u.addedToMap) {
          this.dataContextService.removeMapEntity(u);
        }
        return false;
      }
      return true;
    });
  }
  setFocalPoint(focalPoint: any) {
    if (this.focalPoint && this.focalPoint.addedToMap) {
      this.dataContextService.removeMapEntity(this.focalPoint);
    }
   
      this.focalPoint = new FocalPointMapEntity(
        focalPoint, this.obj.createdAt, this.cameraService, this.coreService, this.windowService, this.dataContextService, this.modalService, this.timelineService , '' ,this?.obj?.label , this?.obj?.eventId
      );
      if (!this.isClosed() && !this.focalPoint.addedToMap) {
        this.dataContextService.addMapEntity(this.focalPoint);
      }
  }
  getFocalPoint() { return this.focalPoint; }
  addDevice(device: any) {
    this.devices[device.getArcAngelId()] = device;
    
    if (this.isBuildingIncident()) {
      // device.hide(); // do not hide in building view
    }
  }

  // Process device status at different times
  countDeviceStatusesForPlayback(statusDates: any[]): void {
    const affectedPerimetersMap: Record<string, any> = {};
    
    if (this.affectedPerimeters) {
      this.affectedPerimeters.forEach((v: any) => {
        affectedPerimetersMap[v.getArcAngelId()] = {
          unSafeUsers: [],
          safeUsers: [],
          unknownUsers: []
        };
      });
    }

    // Create beacon to perimeter dict
    const beaconToPerimDict: Record<string, any> = {};
    this.affectedPerimeters.forEach((p: any) => {
      p.devices = [];
      if (p.beacons) {
        Object.keys(p.beacons).forEach((key: string) => {
          beaconToPerimDict[key] = p;
        });
      }
    });

    if (this.GlobalSettings) {
      this.GlobalSettings.numberOfPlaybackDevicesStatsToDo = statusDates.length;
    }
    
    this.processStatusDates(statusDates, beaconToPerimDict, affectedPerimetersMap, 0);
  }

  processStatusDates(
    statusDates: any[], 
    beaconToPerimDict: Record<string, any>, 
    affectedPerimetersMap: Record<string, any>, 
    n: number
  ): void {
    const numPerBatch = 50;
    const numOfDates = statusDates.length;

    const i1 = n * numPerBatch;
    const i2 = (n + 1) * numPerBatch;
    
    if (i1 >= numOfDates) {
      if (this.GlobalSettings) {
        this.GlobalSettings.numberOfPlaybackDevicesStatsDone = numOfDates;
        this.GlobalSettings.isStatsPlaybackDevices = false;
      }
      return;
    }

    if (this.GlobalSettings) {
      this.GlobalSettings.numberOfPlaybackDevicesStatsDone = n * numPerBatch;
    }

    const dates = statusDates.slice(i1, i2);
    
    dates.forEach((statusDate: any) => {
      const time = parseInt(statusDate);
      const julianDate = Cesium.JulianDate.fromDate(new Date(time));

      const unSafeUsers: string[] = [];
      const unknownUsers: string[] = [];
      const safeUsers: string[] = [];

      // Deep copy the affected perimeters map
      const newAffectedPerimetersMap = this.deepCopy(affectedPerimetersMap);
      
      Object.values(this.devices).forEach((device: any) => {
        const beacon = device.getClosestBeacon(julianDate);
        
        let devicePerimeter;
        const p = beaconToPerimDict[beacon];
        if (p) {
          devicePerimeter = newAffectedPerimetersMap[p.getArcAngelId()];
        }

        if (time >= Math.floor(device.firstStatus.timestamp.getTime() / 1000) * 1000) {
          if (device.isSafe(julianDate)) {
            safeUsers.push(device.getArcAngelId());
            
            if (devicePerimeter) {
              devicePerimeter.safeUsers.push(device.getArcAngelId());
            }
          } else if (device.isUnSafe(julianDate)) {
            unSafeUsers.push(device.getArcAngelId());
            
            if (devicePerimeter) {
              devicePerimeter.unSafeUsers.push(device.getArcAngelId());
            }
          } else {
            // Unknown status
            unknownUsers.push(device.getArcAngelId());
            
            if (devicePerimeter) {
              devicePerimeter.unknownUsers.push(device.getArcAngelId());
            }
          }
        }
      });

      this.dataTimeSlices.addSample(
        julianDate, 
        new IncidentTimeSlice(unSafeUsers, safeUsers, unknownUsers, newAffectedPerimetersMap)
      );
    });

    // Use setTimeout instead of $timeout for Angular
    if (this.$timeout) {
      // AngularJS version
      this.$timeout(() => {
        this.processStatusDates(statusDates, beaconToPerimDict, affectedPerimetersMap, n + 1);
      }, 20);
    } else {
      // Angular version
      setTimeout(() => {
        this.processStatusDates(statusDates, beaconToPerimDict, affectedPerimetersMap, n + 1);
      }, 20);
    }
  }

  // Utility method for deep copying (since we don't have angular.copy)
  private deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    
    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }
    
    if (Array.isArray(obj)) {
      return obj.map(item => this.deepCopy(item));
    }
    
    const copy: any = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        copy[key] = this.deepCopy(obj[key]);
      }
    }
    
    return copy;
  }

  // --- existing methods ---
  removeDevice(device: any) {
    delete this.devices[device.getArcAngelId()];
  }
   getTimeSlice(julianDate: any): any {
    return this.dataTimeSlices.getValue(julianDate);
  }
  clearDevices() {
    this.devices = {};
    this.inDangerUsersLastCount = 0;
    this.unknownUsersLastCount = 0;
    this.safeUsersLastCount = 0;
    this.inDangerUsers = createNonExtrapolatedNumberSampleProperty();
    this.unknownUsers = createNonExtrapolatedNumberSampleProperty();
    this.safeUsers = createNonExtrapolatedNumberSampleProperty();
  }
  setStatus(status: string) { this.status = status; this.obj.status = status; }
  getSafeZones() { return this.safezones; }
  getUpdates() { return this.updates; }
  getDevices() { return this.devices; }
  getStatus() { return this.status; }
  isActive() { return this.status === IncidentMapEntity.ACTIVE_STATE; }
  isPending() { return this.status === IncidentMapEntity.PENDING_STATE; }
  isClosed() { return this.status === IncidentMapEntity.CLOSED_STATE; }
  setActive() { this.status = IncidentMapEntity.ACTIVE_STATE; this.obj.status = IncidentMapEntity.ACTIVE_STATE; }
  setPending() { this.status = IncidentMapEntity.PENDING_STATE; this.obj.status = IncidentMapEntity.PENDING_STATE; }
  setClosed() { this.status = IncidentMapEntity.CLOSED_STATE; this.obj.status = IncidentMapEntity.CLOSED_STATE; }
  getNumberOfUnsafeUsers(date?: any) { return date ? this.inDangerUsers.getValue(date) : this.inDangerUsersLastCount; }
  getNumberOfUnknownUsers(date?: any) { return date ? this.unknownUsers.getValue(date) : this.unknownUsersLastCount; }
  getNumberOfSafeUsers(date?: any) { return date ? this.safeUsers.getValue(date) : this.safeUsersLastCount; }
  getNumberOfFirstResponders() { return this.firstRespondersLastCount; }
 
  reCountDeviceStatuses(): void {
    let inDangerUsers = 0;
    let unknownUsers = 0;
    let safeUsers = 0;
    let firstResponders = 0;
 
    for (const key in this.devices) {
      const device = this.devices[key];
      if (device.isSafe && device.isSafe()) {
        safeUsers++;
      } else if (device.isUnSafe && device.isUnSafe()) {
        inDangerUsers++;
      } else {
        unknownUsers++;
      }
 
      if (device.isFirstResponder && device.isFirstResponder()) {
        firstResponders++;
      }
 
      if (device.setCurrentAltitude) {
        device.setCurrentAltitude(0);
      }
    }
 
    // Set affected perimeters
    if (this.affectedPerimeters !== undefined) {
      // Reset perimeter devices and make dict
      const beaconToPerimDict: Record<string, any> = {};
      this.affectedPerimeters.forEach((p: any) => {
        p.devices = [];
        if (p.beacons) {
          Object.keys(p.beacons).forEach((key: string) => {
            beaconToPerimDict[key] = p;
          });
        }
      });
 
      // Assign devices to perimeters
      Object.values(this.devices).forEach((device: any) => {
        if (device.closestBeacon) {
          if (beaconToPerimDict[device.closestBeacon]) {
            beaconToPerimDict[device.closestBeacon].devices.push(device);
            return;
          }
          this.affectedPerimeters.forEach((p: any) => {
            if (p.beacons && Object.keys(p.beacons).includes(device.closestBeacon)) {
              p.devices.push(device);
              return;
            }
          });
        }
      });
 
      this.affectedPerimeters.forEach((affectedPerimeter: any) => {
        if (affectedPerimeter.setDevices) {
          affectedPerimeter.setDevices();
        }
      });
    }
 
    this.inDangerUsersLastCount = inDangerUsers;
    this.unknownUsersLastCount = unknownUsers;
    this.safeUsersLastCount = safeUsers;
    this.firstRespondersLastCount = firstResponders;
  }
 
  // Perimeter-related methods
  // setAffectedPerimeters(affectedPerimeters: any[]): any[] {
  //   this.affectedPerimeters = [];
  //   this.affectedBeacons = {};
 
  //   affectedPerimeters.forEach((affectedPerimeter: any) => {
  //     this.affectedPerimeters.push(affectedPerimeter);
 
  //     // if (affectedPerimeter.getBeacons) {
  //     //   affectedPerimeter.getBeacons().forEach((affectedBeacon: any) => {
  //     //     this.affectedBeacons[affectedBeacon.id] = affectedBeacon;
  //     //   });
  //     // }
  //   });
 
  //   return this.affectedPerimeters;
  // }
 
  // getAffectedPerimeters(): any[] {
  //   return this.affectedPerimeters;
  // }
 
  // getAffectedPerimeterIds(): string[] {
  //   return this.affectedPerimeterIds;
  // }
 
  // containsPerimeter(perimeterId: string): boolean {
  //   if (!this.affectedPerimeterIds || this.affectedPerimeterIds.length === 0) {
  //     return false;
  //   }
 
  //   return this.affectedPerimeterIds.includes(perimeterId);
  // }
 
  // containsBeacon(beaconId: string): boolean {
  //   if (beaconId && this.affectedBeacons) {
  //     return beaconId in this.affectedBeacons;
  //   }
  //   return false;
  // }
 
  // Additional utility methods
  override hide(): void {
    super.hide();
    let i: number;
 
    this.highGeometryMapEntities.forEach(e => e.hide());
    this.lowGeometryMapEntities.forEach(e => e.hide());
    this.medGeometryMapEntities.forEach(e => e.hide());
 
    if (this.safezones && this.safezones.length > 0) {
      for (i = 0; i < this.safezones.length; i++) {
        if (this.safezones[i].hide) {
          this.safezones[i].hide();
        }
      }
    }
    if (this.updates && this.updates.length > 0) {
      for (i = 0; i < this.updates.length; i++) {
        if (this.updates[i].hide) {
          this.updates[i].hide();
        }
      }
    }
    if (this.focalPoint && this.focalPoint.hide) {
      this.focalPoint.hide();
    }
    if (this.devices) {
      for (const device in this.devices) {
        if (this.devices[device].hide) {
          this.devices[device].hide();
        }
      }
    }
    if (this.outline && this.outline.hide) {
      this.outline.hide();
    }
  }
 
  override show(): void {
    super.show();
    let i: number;
 
    this.highGeometryMapEntities.forEach(e => e.show());
    this.lowGeometryMapEntities.forEach(e => e.show());
    this.medGeometryMapEntities.forEach(e => e.show());
 
    if (this.safezones && this.safezones.length > 0) {
      for (i = 0; i < this.safezones.length; i++) {
        if (this.safezones[i].show) {
          this.safezones[i].show();
        }
      }
    }
    if (this.updates && this.updates.length > 0) {
      for (i = 0; i < this.updates.length; i++) {
        if (this.updates[i].show) {
          this.updates[i].show();
        }
      }
    }
    if (this.devices) {
      for (const device in this.devices) {
        if (this.devices[device].show) {
          this.devices[device].show();
        }
      }
    }
    if (this.focalPoint && this.focalPoint.show) {
      this.focalPoint.show();
    }
    if (this.outline && this.outline.show) {
      this.outline.show();
    }
  }
 
  override getId() { return this.id; }
  override getWindowId() { return this.eventId; }
 
  public setMedGeometry(coordinates: [number, number][]) {
    if (!this.medGeometryMapEntity) {
      this.medGeometryMapEntity = new MedLowGeometryMapEntity(
        this.eventId,
        coordinates,
        this.timestamp,
        Color.ORANGE,
        this.dataContextService,
        this.cameraService,
        this.coreService,
        this.windowService,
        this.modalService,
        this.timelineService
      );
      this.medGeometryMapEntity.setParent(this);
 
      if (!this.isClosed() && !this.medGeometryMapEntity.addedToMap) {
        this.dataContextService.addMapEntity(this.medGeometryMapEntity);
      }
    } else {
      this.medGeometryMapEntity.setCoordinates(coordinates);
    }
  }
 
  public hasMedGeometry(): boolean {
    return !!this.medGeometryMapEntity;
  }
 
  public setLowGeometry(coordinates: [number, number][]) {
    if (!this.lowGeometryMapEntity) {
      this.lowGeometryMapEntity = new MedLowGeometryMapEntity(
        this.eventId,
        coordinates,
        this.timestamp,
        Color.YELLOW,
        this.dataContextService,
        this.cameraService,
        this.coreService,
        this.windowService,
        this.modalService,
        this.timelineService
      );
      this.lowGeometryMapEntity.setParent(this);
 
      if (!this.isClosed() && !this.lowGeometryMapEntity.addedToMap) {
        this.dataContextService.addMapEntity(this.lowGeometryMapEntity);
      }
    } else {
      this.lowGeometryMapEntity.setCoordinates(coordinates);
    }
  }
 
  public hasLowGeometry(): boolean {
    return !!this.lowGeometryMapEntity;
  }

  setAffectedPerimeterIds(affectedPerimeters: any[]): string[] {
    this.affectedPerimeterIds = [];

    for (let i = 0; i < affectedPerimeters.length; i++) {
      this.affectedPerimeterIds.push(affectedPerimeters[i].perimeterId);
    }

    return this.affectedPerimeterIds;
  }

  getAffectedPerimeterIds(): string[] {
    return this.affectedPerimeterIds;
  }

  containsPerimeter(perimeterId: string): boolean {
    if (this.affectedPerimeterIds === undefined || this.affectedPerimeterIds.length === 0) {
      return false;
    }

    for (let i = 0; i < this.affectedPerimeterIds.length; i++) {
      if (perimeterId === this.affectedPerimeterIds[i]) {
        return true;
      }
    }

    return false;
  }

  // Perimeter Entities
  setAffectedPerimeters(affectedPerimeters: any[]): any[] {
    this.affectedPerimeters = [];
    this.affectedBeacons = {};

    affectedPerimeters.forEach((affectedPerimeter) => {
      this.affectedPerimeters.push(affectedPerimeter);

      if (affectedPerimeter.getBeacons && typeof affectedPerimeter.getBeacons === 'function') {
        const beacons = affectedPerimeter.getBeacons();
        if (beacons) {
          // Handle both array and object format for beacons
          if (Array.isArray(beacons)) {
            beacons.forEach((affectedBeacon) => {
              if (affectedBeacon && affectedBeacon.id) {
                this.affectedBeacons[affectedBeacon.id] = affectedBeacon;
              }
            });
          } else if (typeof beacons === 'object') {
            Object.values(beacons).forEach((affectedBeacon: any) => {
              if (affectedBeacon && affectedBeacon.id) {
                this.affectedBeacons[affectedBeacon.id] = affectedBeacon;
              }
            });
          }
        }
      }
    });

    return this.affectedPerimeters;
  }

  getAffectedPerimeters(): any[] {
    return this.affectedPerimeters;
  }

  containsBeacon(beaconId: string): boolean {
    if (beaconId && this.affectedBeacons) {
      return beaconId in this.affectedBeacons;
    }

    return false;
  }
 
  public override setAddedToMap(status: boolean): void {
    super.setAddedToMap(status);
    if (status) {
      if (this.outline) {
        this.dataContextService.addMapEntity(this.outline);
      }
        this.safezones.forEach(sz => this.dataContextService.addMapEntity(sz));
        this.updates.forEach(u => this.dataContextService.addMapEntity(u));
        if (this.focalPoint) {
          this.dataContextService.addMapEntity(this.focalPoint);
        }
        this.highGeometryMapEntities.forEach(e => {
          this.dataContextService.addMapEntity(e);
          e.show?.();
        });
        this.medGeometryMapEntities.forEach(e => {
          this.dataContextService.addMapEntity(e);
          e.show?.();
        });
        this.lowGeometryMapEntities.forEach(e => {
          this.dataContextService.addMapEntity(e);
          e.show?.();
        });
    } else {
      this.safezones.forEach(sz => this.dataContextService.removeMapEntity(sz, true));
      this.updates.forEach(u => this.dataContextService.removeMapEntity(u, true));
      if (this.focalPoint) {
        this.dataContextService.removeMapEntity(this.focalPoint, true);
      }
      if (this.outline) {
        this.dataContextService.removeMapEntity(this.outline, true);
      }
      this.highGeometryMapEntities.forEach(e => this.dataContextService.removeMapEntity(e, true));
      this.medGeometryMapEntities.forEach(e => this.dataContextService.removeMapEntity(e, true));
      this.lowGeometryMapEntities.forEach(e => this.dataContextService.removeMapEntity(e, true));

      if (this.affectedPerimeters) {
        this.affectedPerimeters.forEach(p => {
          p.clearDevices?.();
        });
      }
    }
  }
    reverseCoordinates(coordinates: any[]): any[] {
    const newCoordinates = [];
    for (let c = 0; c < (coordinates?.length ?? 0); c++) {
      const point = coordinates[c];
      let lon: any;
      let lat: any;
      if (Array.isArray(point) && point.length >= 2) {
        lon = point[0];
        lat = point[1];
      } else if (point && typeof point === 'object') {
        lon = point.lon ?? point.lng ?? point.longitude ?? point[0];
        lat = point.lat ?? point.latitude ?? point[1];
      }

      const nLat = typeof lat === 'string' ? Number(lat) : lat;
      const nLon = typeof lon === 'string' ? Number(lon) : lon;
      if (typeof nLat === 'number' && typeof nLon === 'number' && !Number.isNaN(nLat) && !Number.isNaN(nLon)) {
        newCoordinates.push([nLat, nLon]);
      }
    }
    return newCoordinates;
  }
 override hasCustomCamera(): boolean {
      return this.buildingMapEntity !== undefined;
    };
  override viewDetailsWindow(
    scope: any,
    positioning?: string,
    autoSize?: boolean,
    closeCallBack?: () => void,
    windowShape?: string,
    doNotDrag?: boolean,
    showDefaultView?: boolean
  ): void {
    if (this.isMuster) {
    } else {
      // Call parent implementation with all arguments
      super.viewDetailsWindow(
        scope,
        positioning,
        autoSize,
        closeCallBack,
        windowShape,
        doNotDrag,
        showDefaultView
      );
 
      // Dock the window
      if (this.windowService && typeof this.windowService.dockWindow === 'function') {
        this.windowService.dockWindow(this.getWindowId(), 0.33);
      }
 
      // jQuery logic for UI adjustments (if jQuery is available)
      const w: any = window;
      if (this.SessionOptionsService && this.SessionOptionsService.isLiveMode && typeof this.SessionOptionsService.isLiveMode === 'function') {
        if (w.$ && w.$('#sliding-drawer-plugin-panel').hasClass('visible')) {
          w.$('.dockleft').removeClass('dockleft-important-0');
          w.$('.dockleft').addClass('dockleft-important-400');
        } else if (w.$) {
          w.$('.dockleft').removeClass('dockleft-important-400');
          w.$('.dockleft').addClass('dockleft-important-0');
        }
        if (!this.SessionOptionsService.isLiveMode() && w.$) {
          w.$('.dockleft').addClass('dockleft-important-0');
        }
      }
    }
  }
  override showEditWindow(mapEntity: any) {
    if (this.windowService) {
      // return {
      //         component: EventupdateattributevisualizerComponent,
      //         inputs: { entity: this.mapEntityId }
      //       };
      //     const modalPromise = this.windowService.openModalWindow(
      //       mapEntity,
      //       FmvDialogComponent,
      //       "",  undefined,
      //       undefined,
      //       undefined,
      //       { mapEntity },
      //       { windowClass: 'fmv-modal-top' } 
      //     );
      return  this.windowService.openModalWindow(
            this,
            IncidentEditDialogComponent,
            "",  undefined,
            undefined,
            undefined,
             { mapEntity: mapEntity },
          );
      // return this.windowService.openModalWindow(
      //   this,
      //   'IncidentSafeZoneEditDialogController',
      //   'components/arcangel/views/safezone-edit-dialog.html'
      // );
    }
    return Promise.resolve();
  }
}
 
// Helper functions

function createObjectSampleProperty(): Cesium.SampledProperty {
  // Create a proper Cesium SampledProperty with object support
  const sampleProperty = new Cesium.SampledProperty(Object as any);
  
  // Configure extrapolation behavior to match the AngularJS version
  sampleProperty.backwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
  sampleProperty.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
  
  // Set interpolation algorithm to prevent interpolation between samples
  (sampleProperty as any)._interpolationAlgorithm = Cesium.LinearApproximation;
  
  // Set extrapolation durations
  sampleProperty.backwardExtrapolationDuration = 1;
  sampleProperty.forwardExtrapolationDuration = 0;

  return sampleProperty;
}

function createNonExtrapolatedNumberSampleProperty(): Cesium.SampledProperty {
  const sampleProperty = new Cesium.SampledProperty(Number);
  
  // Configure similar to object property
  sampleProperty.backwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
  sampleProperty.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
  sampleProperty.backwardExtrapolationDuration = 1;
  sampleProperty.forwardExtrapolationDuration = 0;

  return sampleProperty;
}
 